// extracted by mini-css-extract-plugin
export default {"benefitsText":"_ih5utz"};